"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _classNames = _interopRequireDefault(require("../../utilities/classNames"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var Svg = function Svg(_ref) {
  var children = _ref.children,
      focusable = _ref.focusable,
      height = _ref.height,
      label = _ref.label,
      width = _ref.width;
  var getClassName = (0, _classNames["default"])(Svg.displayName);
  var baseFontSize = 16;
  /* eslint-disable no-undefined */

  var svg = /*#__PURE__*/_react["default"].cloneElement(children, {
    "aria-hidden": label ? undefined : true,
    "aria-label": label,
    role: label ? "img" : undefined,
    focusable: focusable
  });
  /* eslint-enable no-undefined */


  var svgProps = {
    className: getClassName()
  };
  var innerProps = {
    className: getClassName({
      descendantName: "inner"
    })
  };

  if (width) {
    svgProps.style = {
      width: "".concat(width / baseFontSize, "rem")
    };
  }
  /* eslint-disable no-magic-numbers */


  if (height && width) {
    innerProps.style = {
      paddingBottom: "".concat(height / width * 100, "%")
    };
  }
  /* eslint-enable no-magic-numbers */


  return /*#__PURE__*/_react["default"].createElement("span", svgProps, /*#__PURE__*/_react["default"].createElement("span", innerProps, svg));
};

Svg.displayName = "Svg";
var _default = Svg;
exports["default"] = _default;